import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { ServicesSandbox } from '@app/services/sandboxes/services.sandbox';
import { DbUtils } from '@core/utils';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-complete-data',
    template: `
        <h1 class="u-margin-bottom u-font-size-28 u-font-weight-semibold">{{ 'DASHBOARD.COMPLETE_DATA.TITLE' | translate }}</h1>
        <app-card>
            <app-complete-data-energy
                *ngIf="moveSandbox.showEnergyCompleteData$ | async"
                class="u-display-block"
                [ngClass]="{ 'u-padding-bottom-double u-margin-bottom-double u-bordered-bottom': energyBorder$ | async }"
            ></app-complete-data-energy>

            <app-complete-data-telecom
                *ngIf="moveSandbox.showTelecomCompleteData$ | async"
                class="u-display-block"
                [ngClass]="{
                    'u-padding-bottom-double u-margin-bottom-double u-bordered-bottom': !!DbUtils.getStringId(
                        servicesSandbox.orderedBoilerMaintenanceContract$ | async
                    ),
                }"
            ></app-complete-data-telecom>

            <app-complete-data-boiler-maintenance
                *ngIf="!!DbUtils.getStringId(servicesSandbox.orderedBoilerMaintenanceContract$ | async)"
                class="u-display-block"
            ></app-complete-data-boiler-maintenance>
        </app-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompleteDataComponent {
    public energyBorder$ = combineLatest(
        this.moveSandbox.showTelecomCompleteData$,
        this.servicesSandbox.orderedBoilerMaintenanceContract$,
    ).pipe(
        map(([showTelecomCompleteData, orderedBoilerMaintenanceContract]) => showTelecomCompleteData || orderedBoilerMaintenanceContract),
    );

    constructor(
        public moveSandbox: MoveSandbox,
        public servicesSandbox: ServicesSandbox,
    ) {}

    protected readonly DbUtils = DbUtils;
}
